import { render, staticRenderFns } from "./LoadTab.vue?vue&type=template&id=f7ae6a3c&scoped=true"
import script from "./LoadTab.vue?vue&type=script&lang=ts"
export * from "./LoadTab.vue?vue&type=script&lang=ts"
import style0 from "./LoadTab.vue?vue&type=style&index=0&id=f7ae6a3c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ae6a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7ae6a3c')) {
      api.createRecord('f7ae6a3c', component.options)
    } else {
      api.reload('f7ae6a3c', component.options)
    }
    module.hot.accept("./LoadTab.vue?vue&type=template&id=f7ae6a3c&scoped=true", function () {
      api.rerender('f7ae6a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/LoadTab.vue"
export default component.exports